import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TopicService } from '../topic.service';
import { GeneralExerciseComponent } from '../../General/g-exercise.component';
import { NumberCardsService } from '../number-cards.service';
import { Location } from '@angular/common';
import { SuperExerciseComponent } from '../super-exercise/super-exercise.component';
import { MessageService } from '../../shared/message.service';

@Component({
  selector: 'app-add-card-representation',
  templateUrl: './add-card-representation.component.html',
  styleUrls: ['../topic-style.css', './add-card-representation.component.css']
})
export class AddCardRepresentationComponent extends SuperExerciseComponent {

  //typespecs
  givenNumbers: number[] = [];
  isMultiplication: boolean;
  private countB: number[] = [];

  private solutionA: number[];
  private solutionB: number[];

  added: boolean = false;
  private buckets: number[] = [];
  private size: number[] = [];

  private errorb: number[] = [];

  constructor(protected numberCardsService: NumberCardsService, protected activatedRoute: ActivatedRoute, protected topicService: TopicService, protected messageService: MessageService) {
    super(numberCardsService, activatedRoute, topicService, messageService);
  }

  /** set the typespecific information based on the configuration*/
  setTypeSpecificsFromConfiguration() {
    super.setTypeSpecificsFromConfiguration();
    let typespecs = this.configuration["typespecifics"];
    this.givenNumbers = typespecs["givenNumbers"];
    this.count = this.numberCardsService.getCount(this.cards);
    this.countB = this.numberCardsService.getCount(this.cards);
    this.solutionA = this.numberCardsService.getSolution(this.givenNumbers[0], this.cards);
    this.isMultiplication = typespecs["isMultiplication"];
    if (!this.isMultiplication) {
      this.solutionB = this.numberCardsService.getSolution(this.givenNumbers[1], this.cards);
    }
    let sum = 0;
    for (let number of this.givenNumbers) {
      sum += number;
    }
    this.solution = this.numberCardsService.getSolution(sum, this.cards);
    let index = 0;
    let oldCard = null;
    for (let card of this.cards) {
      if (oldCard != null) {
        this.size[card] = oldCard / card;
      }
      oldCard = card;
      index++;
    }
  }

  checkSolution() {

    let error = false;
    this.error = [];
    this.feedback = "";
    if (!this.added) {
      this.feedback = this.get("addFirst");
      this.messageService.addAlertWithTimeout(this.get("wrongAnswer").concat("\n", this.feedback.toString()), "danger", 10000);
      return;
    }
    let value = this.numberCardsService.getValue(this.count)
    if (value != this.numberCardsService.getValue(this.solution) && this.showHelptext) {
      this.feedback = this.get("hasValue").concat(value.toString(), ". ");
    }
    for (let i = 0; i < this.cards.length; i++) {
      if (this.solution[i] != this.count[this.cards[i]]) {
        error = true;
        if (this.showSymbols) {
          this.error.push(this.cards[i]);
        }
        if (this.showHelptext) {
          if (this.solution[i] > this.count[this.cards[i]]) {
            this.feedback = this.feedback.concat(this.get("tooFewCards"), " ", (new Number(this.cards[i])).toString(10), "\n");
          } else {
            this.feedback = this.feedback.concat(this.get("tooManyCards"), " ", (new Number(this.cards[i])).toString(), "\n");
          }
        }
      }
    }
    if (error) {
      this.messageService.addAlertWithTimeout(this.get("wrongAnswer").concat("\n", this.feedback.toString()), "danger", 10000);
    } else {
      this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
      this.solved = true;
      this.state.solved = true;
      this.saveState();
    }
  }

  /** adds a card of the given value for A
  * @param {number} card - value of card to add
 */
  addedCarda(card: number): void {
    this.count[card]++;
  }

  /** removes a card of the given value for A
   * @param {number} card - value of card to remove
  */
  removeCarda(card: number): void {
    this.count[card]--;
  }

  /** adds a card of the given value for A
    * @param {number} card - value of card to add
   */
  addedCardb(card: number): void {
    this.countB[card]++;
  }

  /** removes a card of the given value for A
   * @param {number} card - value of card to remove
  */
  removeCardb(card: number): void {
    this.countB[card]--;
  }

  /** adds the numbers if possible */
  addNow() {
    if (!this.isExamQuestion()) {
      if (!this.checkSolutionInd(this.count, this.solutionA)) {
        return;
      }
      if (!this.checkSolutionInd(this.countB, this.solutionB)) {
        return;
      }
    }

    for (let index in this.count) {
      this.count[index] += this.countB[index];
      this.buckets[index] = 0;
      this.countB[index] = 0;
    }
    this.added = true;
    this.saveState();
  }

  /** multiplies the numbers if possible */
  multiplyNow() {
    if (!this.isExamQuestion()) {
      if (!this.checkSolutionInd(this.count, this.solutionA)) {
        return;
      }
    }

    for (let index in this.count) {
      this.count[index] *= this.givenNumbers.length;
      this.buckets[index] = 0;
    }
    this.added = true;
    this.saveState();
  }

  /** checks individual Solutions */
  checkSolutionInd(count: number[], solution: number[]): boolean {
    let error = false;
    this.error = [];
    this.feedback = "";
    let value = this.numberCardsService.getValue(count)
    if (value != this.numberCardsService.getValue(solution) && this.showHelptext) {
      this.feedback = this.get("hasValue").concat(value.toString(), ". ");
    }
    for (let i = 0; i < this.cards.length; i++) {
      if (solution[i] != count[this.cards[i]]) {
        error = true;
        if (this.showSymbols) {
          if (solution == this.solutionB) {
            this.errorb.push(this.cards[i]);
          } else {
            this.error.push(this.cards[i]);
          }
        }
        if (this.showHelptext) {
          if (solution[i] > count[this.cards[i]]) {
            this.feedback = this.feedback.concat(this.get("tooFewCards"), " ", (new Number(this.cards[i])).toString(10), "\n");
          } else {
            this.feedback = this.feedback.concat(this.get("tooManyCards"), " ", (new Number(this.cards[i])).toString(), "\n");
          }
        }
      }
    }
    if (error) {
      this.messageService.addAlertWithTimeout(this.get("wrongAnswer").concat("\n", this.feedback.toString()), "danger", 10000);
      return false;
    } else {
      return true;
    }
  }


  /** transform full bucket */
  transformCards(card: number) {
    if (this.buckets[card] > this.count[card]) {
      this.feedback = this.get("errorReduceTransformNotEnoughCards");
      this.messageService.addAlertWithTimeout(this.feedback, "danger", 2000);
      return;
    }
    if (this.buckets[card] < this.size[card]) {
      this.feedback = this.get("errorReduceTransform");
      this.messageService.addAlertWithTimeout(this.feedback, "danger", 2000);
      return;
    }
    if (this.buckets[card] % this.size[card] != 0) {
      this.feedback = this.get("errorReduceTransformWrongNumber");
      this.messageService.addAlertWithTimeout(this.feedback, "danger", 2000);
      return;
    }

    this.count[this.cards[this.cards.indexOf(card) - 1]] += this.buckets[card] / this.size[card];
    this.count[card] -= this.buckets[card];
    this.buckets[card] = 0;
  }

  /** computes the state to save */
  computeState() {
    this.state.typespecific.count = [];
    this.state.typespecific.countB = [];
    this.state.typespecific.buckets = [];
    this.state.typespecific.added = this.added;
    for (let card of this.cards) {
      this.state.typespecific.count.push(this.count[card]);
      this.state.typespecific.countB.push(this.countB[card]);
      this.state.typespecific.buckets.push(this.buckets[card]);
    }
  }

  /** sets to configuration based on the state */
  setTypeSpecificsFromState() {
    super.setTypeSpecificsFromState();
    let buckets = this.state.typespecific.buckets;
    if (buckets != undefined) {
      let i: number = 0;
      for (let card of this.cards) {
        this.buckets[card] = buckets[i];
        i++;
      }
    }
    let countB = this.state.typespecific.countB;
    if (countB != undefined) {
      let i: number = 0;
      for (let card of this.cards) {
        this.countB[card] = countB[i];
        i++;
      }
    }
    this.added = this.state.typespecific.added;
  }

  /** evaluates the current state of the exercise 
    * @returns {number} - returns the total number of points (unweigthed, the maximum is 1)
   */
  evaluate(): number[] {
    let result = 0;
    if (this.added) {
      let r = 0;
      let index = 0;
      for (let counts of this.solution) {
        if (counts == this.count[this.cards[index]] && counts > 0) {
          result++;
        }
        if (counts > 0) {
          r++;
        }
        index++;
      }
      return [3 * Math.max((result) / r, this.state.evaluate), 3];
    } else {
      if (this.isMultiplication) {
        let error = false;
        for (let i = 0; i < this.cards.length; i++) {
          if (this.solutionA[i] != this.count[this.cards[i]]) {
            error = true;
          }
        }
        if (!error) {
          result += 1;
        }
      } else {
        let error = false;
        for (let i = 0; i < this.cards.length; i++) {
          if (this.solutionA[i] != this.count[this.cards[i]]) {
            error = true;
          }
        }
        if (!error) {
          result += 0.5;
        }
        error = false;
        for (let i = 0; i < this.cards.length; i++) {
          if (this.solutionB[i] != this.countB[this.cards[i]]) {
            error = true;
          }
        }
        if (!error) {
          result += 0.5;
        }
      }
    }
    return [1.5 * result, 1.5];
  }

}
